/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Pins, message edits and inbox options (reply lock, signature)
class ConversationToolsAPI extends ApiClient {
  constructor() {
    super('loco', { accountScoped: true });
  }

  pinned() {
    return axios.get(`${this.url}/pinned_conversations`);
  }

  pin(conversationId) {
    return axios.post(`${this.url}/conversations/${conversationId}/pin`);
  }

  unpin(conversationId) {
    return axios.delete(`${this.url}/conversations/${conversationId}/pin`);
  }

  editMessage(conversationId, messageId, content) {
    return axios.patch(
      `${this.url}/conversations/${conversationId}/messages/${messageId}/edit`,
      { content }
    );
  }

  inboxSettings(inboxId) {
    return axios.get(`${this.url}/inboxes/${inboxId}/settings`);
  }

  updateInboxSettings(inboxId, settings) {
    return axios.patch(`${this.url}/inboxes/${inboxId}/settings`, {
      settings,
    });
  }
}

export default new ConversationToolsAPI();
